import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { getUserByUsername } from "../../utils/getUserByUsername";
import { fetchTransactions } from "../utils/fetchTxn";

import DisplayTransactions from "../Display/display";
import Loader from "../../utils/Loader/Loader";

import { useAuth } from "../../context/AuthContext";

const PublicPortfolio = ({ showToast }) => {

    const { username } = useParams();
    const navigate = useNavigate();
    const { userId } = useAuth();

    const [user, setUser] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ready, setReady] = useState(false);
    useEffect(() => {

        const load = async () => {

            try {

                setLoading(true);

                // 🔹 Fetch user
                const u = await getUserByUsername(username);

                if (!u) {
                    setUser(null);
                    setLoading(false);
                    return;
                }

                // 🔹 Privacy check
                const isPrivate = u.privacy === "private";
                const isOwner = userId === u.id;

                if (isPrivate && !isOwner) {

                    showToast(
                        "This profile is private. Contact user to update privacy setting.",
                        "error",
                        5000
                    );

                    navigate("/community");
                    return;
                }

                setUser(u);

                // 🔹 Fetch transactions (WAIT FULLY)
                const txData = await fetchTransactions(
                    u.id,
                    null,
                    {
                        protectedUserId: userId
                    }
                );

                setTransactions(txData);
                setReady(true);
                setLoading(false);

                // 🔹 ONLY AFTER EVERYTHING IS READY
                setLoading(false);

            } catch (err) {

                console.error(err);
                setLoading(false);
            }

        };

        load();

    }, [username, userId]);

    // 🔥 LOADING STATE (strict)
    if (loading || !ready) {
        return <Loader text="Loading portfolio..." />;
    }

    // 🔥 USER NOT FOUND
    if (!user) {
        return (
            <div className="public-container">
                User not found
            </div>
        );
    }

    return (
        <div className="public-container">

            <DisplayTransactions
                externalTransactions={transactions}
                isPublic={true}
                profileUser={user}
                showToast={showToast}
            />

        </div>
    );
};

export default PublicPortfolio;